import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import ButtonComponent from '@prisjakt/ui-button';
import { Column } from '@prisjakt/ui/list/variants';
import { Hideable } from '@prisjakt/ui/hideable';
import { H3Text } from '@prisjakt/ui/text/variants';

export const ChangelogWrapper = styled.div``;

type ModalProps = {
  alternatePosition?: boolean;
};

const modalPosition = css`
  right: 0;
  top: 100%;
`;

const alternateModalPosition = css`
  left: 100%;
  bottom: 0;
`;

export const ChangelogModal = styled(Hideable)<ModalProps>`
  position: absolute;
  background: ${p => p.theme.bg.primary};
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  width: 320px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${p => (p.alternatePosition ? alternateModalPosition : modalPosition)};
`;

export const Main = styled(Column)`
  padding: ${layout.measurements.spacingNormal};
`;

export const Item = styled.div``;

export const Button = styled(ButtonComponent)`
  width: 100%;
`;

export const H3 = styled(H3Text)`
  margin: 0;
`;
